// tslint:disable
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { RegistrationService, SharedService } from '../../../../services';
import { END_STATE } from '../../../../../../common/lib/endPage';
import { branding } from '../../../common/text';

declare const GAMING: boolean;
// tslint:enable

@Component({
    selector: 'registration-error-page',
    styleUrls: ['./registration-error-page.component.scss'],
    templateUrl: './registration-error-page.component.pug'
})
export class RegistrationErrorPage implements OnInit, OnDestroy {
    public error: any;
    public canRemoveFromWaitlist: boolean;
    public removing: boolean;
    public removeFailed: boolean;
    private registrationId: number;

    constructor(private titleService: Title, private sharedService: SharedService,
        private registrationService: RegistrationService, private sanitizer: DomSanitizer) { }

    public ngOnInit() {
        // tslint:disable-next-line
        this.titleService.setTitle('Registration Error');
        let error = this.sharedService.getRegistrationError();
        // End page copy is DOMPurify-sanitized by the server. Angular's own sanitizer would strip the
        // inline styles (e.g. text color) set in the Profiler editor, so trust it as-is
        this.error = {
            message: this.trustHtml(error.message),
            title: this.trustHtml(error.errorTitle)
        };
        this.registrationId = error.registrationId;
        // Only the Waitlisted page offers this, and only when we know which registration to cancel
        this.canRemoveFromWaitlist = error.endState === END_STATE.WAITLISTED && !!error.registrationId;
    }

    public onRemoveFromWaitlistClicked() {
        this.removing = true;
        this.removeFailed = false;
        this.registrationService.cancel(this.registrationId).subscribe(
            () => {
                this.canRemoveFromWaitlist = false;
                this.error = {
                    title: 'Removed from Waitlist',
                    message: `Sorry, we missed you this time! Thank You for being a member of ${branding[GAMING ? 'gaming' : 'pfm']} and we hope to see you at another event soon!`
                };
            },
            (err) => {
                console.log('Remove from waitlist err - ', err);
                this.removing = false;
                this.removeFailed = true;
            }
        );
    }

    private trustHtml(html: string): SafeHtml {
        return html ? this.sanitizer.bypassSecurityTrustHtml(html) : html;
    }

    public ngOnDestroy() {
        this.sharedService.setRegistrationError({});
    }
}
